import { Chip } from '@mui/material'
import React from 'react'

// Entertainment

// Comedy
// Music
// Art

// Business and Technology

// Business
// Technology
// Software
// Electronics

// Lifestyle and Wellness

// Fashion
// Beauty
// Fitness
// Food
// Wellness

// Sports and Gaming

// Sports
// Video games

// Culture and History

// History
// Crime

export default function ClassificationTag({
  tagName,
}: {
  tagName: string
}): JSX.Element {
  const tagColors: {
    [key: string]:
      | 'primary'
      | 'error'
      | 'secondary'
      | 'warning'
      | 'default'
      | 'success'
  } = {
    Business: 'primary',
    Sports: 'error',
    'Video games': 'error',
    Technology: 'primary',
    Software: 'primary',
    Electronics: 'primary',
    Fashion: 'secondary',
    Beauty: 'secondary',
    Fitness: 'secondary',
    Food: 'secondary',
    Comedy: 'success',
    History: 'warning',
    Crime: 'warning',
    Music: 'success',
    Art: 'success',
    Wellness: 'secondary',
    Miscellaneous: 'default',
  }
  return (
    <div>
      <Chip label={tagName} color={tagColors[tagName]} />
    </div>
  )
}
